import { ExclusionListFormWebComponent } from './component/ExclusionListFormWebComponent';
import { WEB_COMPONENT_EXCLUSION_LIST_FORM } from '../../webcomponents.constants';

/**
 * The exclusion list form component for adding exclusion lists
 * @link https://bitdefender.atlassian.net/wiki/spaces/GZDOCS/pages/1153468618/Global+Exclusions+Page
 */
export { ExclusionListFormWebComponent };

window.customElements.define(WEB_COMPONENT_EXCLUSION_LIST_FORM, ExclusionListFormWebComponent);
